<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>

        <app-navbar></app-navbar>
        <div class="container mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {
                      title: 'Dashboard',
                      url: 'dashboard'
                    },
                    {
                      title: 'Link 1',
                      url: 'link-1'
                    },
                    {
                      title: 'Link 2',
                      url: 'link-1'
                    },
                    {
                      title: 'Active',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
          </div>
          <div class="heading mt-3">
            <h3 class="text-secondary">Notifications</h3>
          </div>
          <div class="col-sm-12">
            <div class="form-group form-row">
              <h6 class="sub-frm-title">Check Notifications</h6>
              <div class="col-sm-12">
                <!-- <h2 class="text-justify text-center" style="margin:20%">Coming Soon</h2> -->
                <vs-row vs-justify="center" class="mt-1">
                  <vs-col type="flex" vs-w="12">
                    <vs-list>
                      <!-- <vs-list-header title></vs-list-header> -->
                      <vs-list-item title="Muhammad Ammad" subtitle="Top Contributor">
                        <template slot="avatar">
                          <avatar style="margin-right:5px;" fullname="Muhammad Ammad" size="35"></avatar>
                        </template>
                        <vs-chip color="warning">8/26/2019</vs-chip>
                      </vs-list-item>
                      <vs-list-item title="Ozeer Ahmad" subtitle="Top Contributor">
                        <template slot="avatar">
                          <avatar style="margin-right:5px;" fullname="Ozeer Ahmad" size="35"></avatar>
                        </template>
                        <vs-chip color="warning">8/26/2019</vs-chip>
                      </vs-list-item>
                      <vs-list-item title="Ayesha Riaz" subtitle="Top Contributor">
                        <template slot="avatar">
                          <avatar style="margin-right:5px;" fullname="Ayesha Riaz" size="35"></avatar>
                        </template>
                        <vs-chip color="warning">8/26/2019</vs-chip>
                      </vs-list-item>
                      <vs-list-item title="Imran Azim" subtitle="Top Contributor">
                        <template slot="avatar">
                          <avatar style="margin-right:5px;" fullname="Imran Azim" size="35"></avatar>
                        </template>
                        <vs-chip color="warning">8/26/2019</vs-chip>
                      </vs-list-item>
                      <vs-list-item title="Nasir Ullah" subtitle="Top Contributor">
                        <template slot="avatar">
                          <avatar style="margin-right:5px;" fullname="Nasir Ullah" size="35"></avatar>
                        </template>
                        <vs-chip color="warning">8/26/2019</vs-chip>
                      </vs-list-item>
                    </vs-list>
                  </vs-col>
                </vs-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar-component";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
export default {
  data: () => ({
    isSidebar: false
  }),
  components: {
    Avatar,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.b-list-group-item.opt-list-item {
  border: none !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
</style>
